import React from 'react';
import { useNavigate } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ReviewsIcon from '@mui/icons-material/Reviews';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import logo from './assets/logo.jpg';

const NAV_ITEMS = [
  {
    key: 'orders',
    label: 'Orders',
    icon: ShoppingCartIcon,
    path: '/admin-portal'
  },
  {
    key: 'products',
    label: 'Products',
    icon: Inventory2Icon,
    path: '/admin-portal/products'
  },
  {
    key: 'testimonials',
    label: 'Testimonials',
    icon: ReviewsIcon,
    path: '/admin-portal/testimonials'
  },
  {
    key: 'brands',
    label: 'Manage Brands',
    icon: BrandingWatermarkIcon,
    path: '/admin-portal/brands'
  },
  {
    key: 'shippingFees',
    label: 'Shipping Fees',
    icon: LocalShippingIcon,
    path: '/admin-portal/shipping-fees'
  }
];

const AdminSidebar = ({ activeItem = 'orders' }) => {
  const navigate = useNavigate();

  return (
    <nav className="hidden md:flex flex-col sticky top-20 self-start h-[calc(100vh-80px)] overflow-y-auto bg-white border-r-2 border-gray-200 w-64 shrink-0 z-30">
      <div className="p-4 border-b-2 border-gray-200 mb-2 flex flex-col items-center">
        <div className="w-16 h-16 rounded-full border-2 border-gray-200 overflow-hidden mb-2 flex items-center justify-center">
          <img src={logo} alt="MMK Industries Logo" className="w-full h-full object-cover" />
        </div>
        <h2 className="text-lg font-bold text-primary text-center">MMK Industries</h2>
      </div>
      <ul className="flex flex-col flex-grow">
        {NAV_ITEMS.map((item) => {
          const isActive = item.key === activeItem;
          const Icon = item.icon;

          return (
            <li key={item.key}>
              <button
                className={`w-full flex items-center px-4 py-3 transition-all border-l-4 text-left ${
                  isActive
                    ? 'bg-primary text-white font-bold border-blue-300'
                    : 'text-gray-600 hover:bg-gray-100 border-transparent'
                }`}
                onClick={() => navigate(item.path)}
              >
                <Icon className="mr-2 !w-5 !h-5" />
                <span className="text-sm uppercase tracking-wider">{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default AdminSidebar;
